<script>
import ForgotPassUserDataPageCcnsw from "@/views/auth/ccnsw/forgot_pass-userdata.vue";
import ForgotPassUserDataPageStw from "@/views/auth/statewide/forgot_pass-userdata.vue";
import ForgotPassUserDataPageDefault from "@/views/auth/default/forgot_pass-userdata.vue";
import {mapGetters} from "vuex";

export default {
  components: {ForgotPassUserDataPageDefault, ForgotPassUserDataPageCcnsw, ForgotPassUserDataPageStw},
  data () {
    return {
      host: '',
    }
  },
  methods: {},
  mounted () {
    this.host = window.location.hostname
  },
  computed: {
    ...mapGetters({
      isStatewide: 'isStatewide'
    }),
    isCCNSW () {
      return (this.host == 'ccnsw.partssearch.com.au')
    },
  }
}
</script>

<template>
  <forgot-pass-user-data-page-ccnsw v-if="isCCNSW"></forgot-pass-user-data-page-ccnsw>
  <forgot-pass-user-data-page-stw v-else-if="isStatewide"></forgot-pass-user-data-page-stw>
  <forgot-pass-user-data-page-default v-else></forgot-pass-user-data-page-default>
</template>
